import { ECompareActionTypes } from '../../actions/compare';
import { ICompareState } from '../../types/compare';

const initialState: ICompareState = {
  isAdded: false,
};

export function compareReducer(state: ICompareState = initialState, action?: { type?: string }): ICompareState {
  switch (action?.type) {
    case ECompareActionTypes.ToggleCompare:
      return {
        ...state,
        isAdded: !state.isAdded,
      };

    default:
      return state;
  }
}
